import { render, staticRenderFns } from "./ProductSubCategoryModal.vue?vue&type=template&id=0e357146&scoped=true&"
import script from "./ProductSubCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e357146",
  null
  
)

export default component.exports